/**
 * Ryan O'Dowd
 * 2018-11-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, safeAreaInsets, isDarkMode}) => {
  return {
    menu: {
      flex: 1,
      display: 'flex',
      backgroundColor: isDarkMode ? colors.primary : colors.primaryDark,
    },
    profileWrapper: {
      display: 'flex',
      paddingHorizontal: 8,
      marginTop: safeAreaInsets.top || 8,
      paddingBottom: 4,
    },
    avatarContainer: {
      display: 'flex',
    },
    avatarAndMetadata: {
      display: 'flex',
      flexDirection: 'row',
    },
    optionsWrapper: {
      display: 'flex',
      paddingTop: 8,
      marginBottom: safeAreaInsets.bottom,
    },
    options: {
      paddingBottom: 16,
    },
    avatar: {
      width: globalScale * 54,
      height: globalScale * 54,
      overflow: 'hidden',
      borderRadius: globalScale * 16,
      backgroundColor: colors.primaryDark,
    },
    nameAndEmailWrapper: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginLeft: 8,
    },
    name: {
      color: colors.white,
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 18,
    },
    username: {
      fontFamily: fonts.primaryItalic,
      color: colors.white,
      fontSize: globalScale * 16,
      width: '100%',
      fontStyle: 'italic', // @TODO: shouldn't be necessary on ios (think this is a rn bug)
    },
    option: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingLeft: globalScale * 10,
      paddingTop: globalScale * 8,
      paddingBottom: globalScale * 4,
    },
    icon: {
      fontSize: globalScale * 18,
      color: colors.white,
    },
    optionTextWrapper: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
    optionText: {
      // @TODO: width: '100%', // otherwise, android truncates some of the options (like the "t" in "About")
      flex: 1,
      color: colors.white,
      fontSize: globalScale * 16,
      marginLeft: 8,
      marginRight: 8,
    },
    horizontalRule: {
      marginTop: 8,
    },
  };
};

export default getStyles;
